import React, { useEffect } from "react";
import FormRenderer from "../organisms/FormRenderer";
import { useInFormation } from "../Context/InFormationContext";
import ClaimInformationContainer from "./KNT/ClaimInformationContainer";
import PersonInformationContainer from "./KNT/PersonInformationContainer";
import AddressInformationContainer from "./KNT/AddressinformationContainer";
const KNTFormContainer = (props) => {
    const { setInFormation } = useInFormation();
    useEffect(() => {
        setInFormation({
            title: "Informatieaanvraag houdergegevens kenteken",
        });
    }, []);
    const steps = [
        {
            component: ClaimInformationContainer,
            url: "/overtreding",
            title: "Overtredinggegevens",
            stepIndex: 0,
        },
        {
            component: PersonInformationContainer,
            url: "/soort-persoon",
            title: "Persoonsgegevens",
            stepIndex: 1,
        },
        {
            component: AddressInformationContainer,
            url: "/adresgegevens",
            title: "Adresgegevens",
            stepIndex: 2,
        },
    ];
    return React.createElement(FormRenderer, Object.assign({ formCode: "KNT", steps: steps }, props));
};
export default KNTFormContainer;
